import ActivateKitBtnMobile from './ActivateKitBtnMobile'

export default ActivateKitBtnMobile
